var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServeSportsArenas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 51,
    viewBox: "0 0 45 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5344 6.96582H10.5169C8.51211 6.96582 6.89258 8.50012 6.89258 10.3992V23.5771H13.5889C14.4822 19.605 17.9941 16.6217 22.2014 16.6217C26.4054 16.6217 29.9241 19.605 30.814 23.5771H37.2921V10.3992C37.2921 8.50012 35.6657 6.96582 33.6677 6.96582H30.8481V10.2458H13.5344V6.96582Z",
    fill: "#F4D35E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1 20.4434C19.9179 20.4434 18.0631 21.8072 17.3301 23.7233H26.8768C26.1438 21.8072 24.2924 20.4434 22.1 20.4434Z",
    fill: "#F4D35E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1962 30.4125C24.4328 30.4125 26.3081 29.0692 26.99 27.2178H17.4023C18.0843 29.0692 19.9595 30.4125 22.1962 30.4125Z",
    fill: "#F4D35E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2014 34.4496C17.9225 34.4496 14.3458 31.3708 13.5344 27.293H6.89258V40.6038C6.89258 42.4961 8.51552 44.0373 10.5237 44.0373H13.4287V40.5561H30.6878V44.0373H33.7189C35.7237 44.0373 37.3466 42.4961 37.3466 40.6038V27.293H30.8685C30.0536 31.3674 26.4804 34.4496 22.2014 34.4496Z",
    fill: "#F4D35E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4114 0H1.69795C0.760329 0 0 0.756919 0 1.68773V49.3123C0 50.2431 0.760329 51 1.69795 51H42.4114C43.349 51 44.1093 50.2431 44.1093 49.3123V1.68773C44.1127 0.756919 43.3524 0 42.4114 0ZM40.9862 47.8018H27.2048V44.1809H17.1159V47.8018H3.19475V3.05154H17.1159V6.46109H27.1161V3.05154H40.9862V47.8018Z",
    fill: "#F4D35E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServeSportsArenas);
export default __webpack_public_path__ + "static/media/serve_sports_arenas.657107ce62d1f59ec33a3b4a6bf6c9db.svg";
export { ForwardRef as ReactComponent };